import { createAction } from 'typesafe-actions';

export const sessionToastDelete = createAction('SESSION_TOAST:DELETE')<{ id: string }>();
export const sessionShowHistory = createAction('SESSION_SHOW_HISTORY')<{ showHistory: boolean }>();
export const sessionReset = createAction('SESSION:RESET')();
